import React, { useState } from 'react'
import { useTheme } from '../../../components/hooks/useTheme';
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";

type Props = {
    facebookUrl: string;
    setFacebookUrl: (value: string) => void;
    twitterUrl: string;
    setTwitterUrl: (value: string) => void;
    instagramUrl: string;
    setInstagramUrl: (value: string) => void;
    disabled: boolean;
}

const SocialMedia = ({
    facebookUrl,
    setFacebookUrl,
    twitterUrl,
    setTwitterUrl,
    instagramUrl,
    setInstagramUrl,
    disabled
}: Props) => {
    const { themeStyles } = useTheme();
    const [isExpanded, setIsExpanded] = useState<boolean>(true);

    const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const isValid = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#-]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm.test(value);
        e.target.setCustomValidity(isValid ? '' : 'Please enter a valid website URL');
        return value;
    }


    return (
        <div>
            <h5 className="mb-0 flex justify-start items-center cursor-pointer select-none"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                {isExpanded ? (
                    <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                ) : (
                    <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                )}{" "}
                <div className="w-full flex flex-row justify-between items-center">
                    <div style={{ color: themeStyles.topBar.textColor }}>Social Media Links</div>
                </div>
            </h5>
            <hr />

            {isExpanded &&
                <div className="w-full px-2 pt-4">
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Facebook URL</label>
                            <input
                                type="text"
                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                value={facebookUrl}
                                disabled={disabled}
                                onChange={(e) => setFacebookUrl(handleUrlChange(e))}
                                required
                            />
                        </div>

                        <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>X (formerly Twitter) URL</label>
                            <input
                                type="text"
                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                value={twitterUrl}
                                disabled={disabled}
                                onChange={(e) => setTwitterUrl(handleUrlChange(e))}
                                required
                            />
                        </div>

                        <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Instagram URL</label>
                            <input
                                type="text"
                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                value={instagramUrl}
                                disabled={disabled}
                                onChange={(e) => setInstagramUrl(handleUrlChange(e))}
                                required
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default SocialMedia